import ComparisonGraph from './ComparisonGraph'

export default ComparisonGraph;